import { render } from "./BottomMenu.vue?vue&type=template&id=1d783cd9"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=1d783cd9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__